export enum SiteMembershipRole {
  Member = 'Member',
  AccountAdmin = 'AccountAdmin',
}

export interface SiteRole {
  siteId: number;
  role: SiteMembershipRole;
}

export function roleOf(isAccountAdmin: boolean): SiteMembershipRole {
  return isAccountAdmin ? SiteMembershipRole.AccountAdmin : SiteMembershipRole.Member;
}

/** The role on the site when the user has one there, else the global flag: staff on a site they are not a member of,
 * or a gateway that does not list roles yet. */
export function isAccountAdminOn(
  sites: SiteRole[] | undefined,
  siteId: number | undefined,
  isSiteAdmin: boolean,
): boolean {
  const site = sites?.find((item) => +item.siteId === +siteId);
  return site ? site.role === SiteMembershipRole.AccountAdmin : isSiteAdmin;
}

/** The role on each of the user's real sites, from `sites` where it lists one, else the global flag. */
export function siteRolesOf(user: { siteIds?: number[]; sites?: SiteRole[]; isSiteAdmin: boolean }): SiteRole[] {
  return (user.siteIds ?? [])
    .filter((siteId) => +siteId > 0)
    .map((siteId) => ({ siteId: +siteId, role: roleOf(isAccountAdminOn(user.sites, siteId, user.isSiteAdmin)) }));
}
